module.exports = __webpack_public_path__ + "img/instagram.37cb03bd.svg";